<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="main-card-body">
        <div class="body-header d-flex request-page-header">
          <div class="request-page-title">
            <h4>Danh sách yêu cầu</h4>
          </div>
          <div class="text-right request-page-actions">
            <div class="text-right2 request-page-actions__inner">
              <el-button class="btn-back" @click="fn_goBack"
                >Quay lại</el-button
              >
              <el-button
                @click="fn_tableShowFormSearch()"
                type="info"
                class="btn-default"
                >Ẩn/hiện tìm kiếm</el-button
              >
            </div>
          </div>
        </div>
        <div class="main-body">
          <!-- FILTERS -->
          <div class="main-body-search mb-3">
            <b-collapse
              :visible="mData.tableRules.showFormSearch"
              id="myFormSearch"
            >
              <el-card>
                <el-form
                  ref="myForm"
                  label-position="top"
                  @submit.native.prevent
                  label-width="120px"
                  :model="mData.tableRules.dataSearch.value"
                  :rules="mData.tableRules.dataSearch.valid"
                >
                  <b-row>
                    <b-col lg="4" md="6" sm="6">
                      <el-form-item label="Nhân viên yêu cầu" prop="">
                        <el-select
                          v-model="
                            mData.tableRules.dataSearch.value.employee_id
                          "
                          clearable
                          filterable
                        >
                          <el-option
                            v-for="item in mData.listEmployee"
                            :key="item.id"
                            :label="fn_setLabelRespectively(item)"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col lg="4" md="6" sm="6">
                      <el-form-item label="Người duyệt" prop="">
                        <el-select
                          v-model="
                            approval_user_id
                          "
                          clearable
                          filterable
                        >
                          <el-option
                            v-for="item in mData.listEmployee"
                            :key="item.id"
                            :label="fn_setLabelRespectively(item)"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col lg="4" md="6" sm="6">
                      <el-form-item label="Phân loại" prop="">
                        <el-select
                          v-model="mData.tableRules.dataSearch.value.type"
                          clearable
                          filterable
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listLoaiLyDo"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col lg="4" md="6" sm="6">
                      <el-form-item label="Trạng thái" prop="">
                        <el-select
                          v-model="searchStatus"
                          :disabled="tabName != 'ALL'"
                          clearable
                          filterable
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listTrangThaiForm"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                          <el-option
                            v-if="tabName == 'NEED_APPROVAL'"
                            label="Cần duyệt"
                            value="NEED_APPROVAL"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col lg="4" md="6" sm="6">
                      <el-form-item label="Thời gian tạo từ" prop="">
                        <el-date-picker
                          ref="createdAtFromPicker"
                          type="date"
                          v-model="mData.created_atFrom"
                          prefix-icon="isax-calendar-1"
                          :clearable="false"
                          format="dd/MM/yyyy"
                          value-format="dd/MM/yyyy"
                          placeholder="dd/mm/yyyy"
                          @change="fn_handleCreatedAtDateConfirm('created_atFrom')"
                          @blur="fn_handleCreatedAtDateBlur('created_atFrom')"
                          @keyup.enter.native="fn_handleCreatedAtDateBlur('created_atFrom')"
                        ></el-date-picker>
                      </el-form-item>
                    </b-col>
                    <b-col lg="4" md="6" sm="6">
                      <el-form-item label="Thời gian tạo tới" prop="">
                        <el-date-picker
                          ref="createdAtToPicker"
                          type="date"
                          v-model="mData.created_atTo"
                          prefix-icon="isax-calendar-1"
                          :clearable="false"
                          format="dd/MM/yyyy"
                          value-format="dd/MM/yyyy"
                          placeholder="dd/mm/yyyy"
                          @change="fn_handleCreatedAtDateConfirm('created_atTo')"
                          @blur="fn_handleCreatedAtDateBlur('created_atTo')"
                          @keyup.enter.native="fn_handleCreatedAtDateBlur('created_atTo')"
                        ></el-date-picker>
                      </el-form-item>
                    </b-col>
                  </b-row>
                  <el-form-item class="text-center mb-0">
                    <el-button
                      class="btn-default btn-search"
                      native-type="submit"
                      @click="fn_tableSearch()"
                      >Tìm kiếm</el-button
                    >
                  </el-form-item>
                </el-form>
              </el-card>
            </b-collapse>
          </div>
          <!-- Tabs -->
          <b-row class="ml-3 request-tabs-row">
            <b-col md="10" class="request-tabs-col">
              <b-row>
                <b-col md="12" class="request-tabs-wrapper">
                  <el-tabs
                    class="request-status-tabs"
                    type="card"
                    @tab-click="handleClick"
                    v-model="activeTab"
                  >
                    <el-tab-pane
                      :name="item.name"
                      v-for="item in mData.dataDefault.listTrangThai"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-tab-pane>
                  </el-tabs>
                </b-col>
              </b-row>
            </b-col>
            <b-col md="2" class="text-right mt-2 p-0 request-unhandled-filter" v-if="tabName == 'NEED_APPROVAL' && !currentProfile.type">
              <b-form-checkbox
                v-model="myReq"
                @change="fn_getListReqNeedApproval"
              >
                Tôi chưa xử lý
              </b-form-checkbox>
            </b-col>
          </b-row>
          <!-- Table -->
          <div class="main-body-table request-list-section">
            <div
              class="bulk-request-actions"
              v-if="tabName == 'NEED_APPROVAL'"
            >
              <el-checkbox
                v-model="selectAllCurrentPage"
                class="bulk-request-actions__select-all"
                :indeterminate="isCurrentPageSelectionIndeterminate"
                :disabled="selectableRequestsOnPage.length == 0 || isBulkProcessing"
              >
                Chọn tất cả
              </el-checkbox>
              <span class="bulk-request-actions__count">
                Đã chọn {{ selectedRequests.length }}
              </span>
              <el-button
                class="bulk-request-actions__button"
                type="success"
                plain
                round
                size="mini"
                :disabled="selectedRequests.length == 0 || isBulkProcessing"
                @click="fn_handleBulkApprove"
              >
                <i class="fas fa-check-circle"></i>
                Duyệt
              </el-button>
              <el-button
                class="bulk-request-actions__button"
                type="info"
                plain
                round
                size="mini"
                :disabled="selectedRequests.length == 0 || isBulkProcessing"
                @click="fn_handleBulkDisapprove"
              >
                <i class="el-icon-error"></i>
                Từ chối
              </el-button>
            </div>
            <el-table
              ref="requestTable"
              class="request-desktop-table"
              :data="dataPerPage"
              :border="false"
              :show-header="false"
              @sort-change="fn_tableSortChange"
              @selection-change="fn_selectionChange"
              style="width: 100%"
            >
              <el-table-column
                v-if="tabName == 'NEED_APPROVAL'"
                type="selection"
                width="46"
                align="center"
                :selectable="fn_isRowSelectable"
              ></el-table-column>
              <el-table-column
                prop="name"
                label="Tên nhân viên"
                min-width="210"
                align="center"
              >
                <template slot-scope="scope">
                  <div class="d-flex align-items-center">
                    <el-avatar :src="scope.row.avt ? scope.row.avt : 'img/company.jpg'" class="mr-2"></el-avatar>
                    <el-popover
                      placement="top-start"
                      trigger="hover"
                      :open-delay="800"
                      :content="scope.row.name"
                    >
                      <div class="content name" slot="reference">
                        <span>{{ scope.row.name }}</span>
                      </div>
                    </el-popover>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="loai"
                label="Phân loại"
                align="center"
                min-width="110"
              >
                <template slot-scope="scope">
                  <div class="bold">
                    {{ scope.row.loai }}
                  </div> </template
                >>
              </el-table-column>
              <el-table-column prop="content" label="Nội dung" min-width="300">
                <template slot-scope="scope">
                  <el-popover
                    placement="top-start"
                    trigger="hover"
                    :open-delay="800"
                    :content="fn_getRequestContentDisplay(scope.row)"
                  >
                    <div class="content" slot="reference">
                      <span class="content"
                        >Nội dung: {{ fn_getRequestContentDisplay(scope.row) }}</span
                      >
                    </div>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column
                prop="status_format"
                align="center"
                label="Trạng thái"
                min-width="100"
              >
                <template slot-scope="scope">
                  <div
                    :class="{
                      'status__block': true,
                      'approved': scope.row.status_format == 'Đã duyệt',
                      'waiting': scope.row.status_format == 'Chờ duyệt',
                      'rejected': scope.row.status_format == 'Từ chối',
                      'cancel': scope.row.status_format == 'Hủy bỏ'
                    }"
                  >
                    {{ scope.row.status_format }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="created_at"
                label="Thời gian tạo"
                align="center"
                min-width="120"
                :sortable="mData.tableRules.allowSorting"
              >
                <template slot-scope="scope">
                  {{ fn_formatTime(scope.row.created_at).slice(-5) }}
                  {{ fn_formatTime(scope.row.created_at).slice(0, 10) }}
                </template>
              </el-table-column>
              <el-table-column
                label="Thao tác"
                align="left"
                :min-width="tabName == 'NEED_APPROVAL' ? 155 : 60"
              >
                <template slot-scope="scope">
                  <el-button
                    plain
                    round
                    size="mini"
                    @click="fn_handle('detail', scope.$index, scope.row)"
                    v-b-popover.hover.left="aLang.c_view"
                    v-if="scope.row.showBtnDetail"
                  >
                    <i class="fa fa-eye"></i>
                  </el-button>
                  <el-button
                    type="success"
                    plain
                    round
                    size="mini"
                    @click="fn_handle('approve', scope.$index, scope.row)"
                    v-b-popover.hover.left="aLang.c_approve"
                    v-if="
                      tabName == 'NEED_APPROVAL' && scope.row.showBtnApproval
                    "
                  >
                    <i class="fas fa-check-circle"></i>
                  </el-button>
                  <el-button
                    type="info"
                    plain
                    round
                    size="mini"
                    @click="fn_handle('disapprove', scope.$index, scope.row)"
                    v-b-popover.hover.left="aLang.c_disapprove"
                    v-if="
                      tabName == 'NEED_APPROVAL' && scope.row.showBtnApproval
                    "
                  >
                    <i class="el-icon-error"></i>
                  </el-button>
                  <!-- <el-button
                    type="danger"
                    plain
                    round
                    size="mini"
                    @click="fn_handle('delete', scope.$index, scope.row)"
                    v-b-popover.hover.left="aLang.c_delete"
                  >
                    <i class="fas fa-trash-alt"></i>
                  </el-button> -->
                  <!-- v-if="
                      (mData.dataDefault.listFeature.includes('FT1005') &&
                        tabName == 'WAITING_FOR_APPROVAL') && currentUser.id == scope.row.employee_id ||
                      (mData.dataDefault.listFeature.includes('FT1005') &&
                        tabName == 'APPROVED') && currentUser.id == scope.row.employee_id ||
                      (mData.dataDefault.listFeature.includes('FT1005') &&
                        tabName == 'REJECTED') && currentUser.id == scope.row.employee_id
                    " -->
                </template>
              </el-table-column>
            </el-table>
            <div class="request-mobile-list">
              <div
                class="request-card"
                v-for="(item, index) in dataPerPage"
                :key="item.id || index"
              >
                <div class="request-card__header">
                  <el-checkbox
                    v-if="tabName == 'NEED_APPROVAL' && item.showBtnApproval"
                    class="request-card__selection"
                    :value="fn_isRequestSelected(item)"
                    :disabled="isBulkProcessing"
                    @change="fn_toggleRequestSelection(item, $event)"
                  ></el-checkbox>
                  <el-avatar :src="item.avt ? item.avt : 'img/company.jpg'"></el-avatar>
                  <div class="request-card__identity">
                    <div class="request-card__name">{{ item.name }}</div>
                    <div class="request-card__type">{{ item.loai }}</div>
                  </div>
                </div>
                <div class="request-card__content">
                  <span>Nội dung:</span> {{ item.content }}
                </div>
                <div class="request-card__meta">
                  <div
                    :class="{
                      'status__block': true,
                      'approved': item.status_format == 'Đã duyệt',
                      'waiting': item.status_format == 'Chờ duyệt',
                      'rejected': item.status_format == 'Từ chối',
                      'cancel': item.status_format == 'Hủy bỏ'
                    }"
                  >
                    {{ item.status_format }}
                  </div>
                  <div class="request-card__time">
                    {{ fn_formatTime(item.created_at).slice(-5) }}
                    {{ fn_formatTime(item.created_at).slice(0, 10) }}
                  </div>
                </div>
                <div class="request-card__actions">
                  <el-button
                    plain
                    round
                    size="mini"
                    @click="fn_handle('detail', index, item)"
                    v-if="item.showBtnDetail"
                  >
                    <i class="fa fa-eye"></i>
                    <span>Xem chi tiết</span>
                  </el-button>
                  <el-button
                    type="success"
                    plain
                    round
                    size="mini"
                    @click="fn_handle('approve', index, item)"
                    v-if="tabName == 'NEED_APPROVAL' && item.showBtnApproval"
                  >
                    <i class="fas fa-check-circle"></i>
                    <span>Duyệt</span>
                  </el-button>
                  <el-button
                    type="info"
                    plain
                    round
                    size="mini"
                    @click="fn_handle('disapprove', index, item)"
                    v-if="tabName == 'NEED_APPROVAL' && item.showBtnApproval"
                  >
                    <i class="el-icon-error"></i>
                    <span>Từ chối</span>
                  </el-button>
                </div>
              </div>
            </div>
            <b-row class="mt-2 request-pagination-row" v-if="mData.tableRules.allowPaging">
              <div class="col-md-12 text-right request-pagination-col">
                <el-pagination
                  class="request-pagination"
                  @size-change="fn_tableSizeChange"
                  @current-change="fn_tableCurentChange"
                  @prev-click="fn_tablePrevClick"
                  @next-click="fn_tableNextClick"
                  :page-sizes="mData.tableRules.lengthMenu"
                  :page-size="mData.tableRules.limit"
                  :current-page="Number(mData.tableRules.page)"
                  background
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="mData.tableRules.total"
                  :pager-count="5"
                ></el-pagination>
              </div>
            </b-row>
          </div>
        </div>
      </div>
    </div>
    <!-- Dialog hướng dẫn hoàn công -->
    <el-dialog
      title="Hướng dẫn hoàn công"
      :visible.sync="dialogInstruction"
      width="30%"
    >
      <el-form
        ref="myForm"
        label-position="top"
        @submit.native.prevent
        label-width="135px"
      >
        <ul style="list-style: none; padding-left: 10px">
          <li style="word-break: break-word">
            <strong>Bước 1:</strong> Vào bảng công tính lại công thực tế bằng
            tay và duyệt lại.
          </li>
          <li style="word-break: break-word">
            <strong>Bước 2:</strong> Hoàn phép ở màn hình cấu hình ngày nghỉ
            nhân viên.
          </li>
        </ul>
        <div class="text-center mb-0">
          <el-button class="btn-default" @click="fn_delete(idReqDelete)"
            >Ok</el-button
          >
        </div>
      </el-form>
    </el-dialog>
    <!-- Start dialog Reject sign -->
    <el-dialog
      class="dialog__reject-request"
      :visible.sync="dialogRejectRequest"
      :show-close="false"
      :close-on-click-modal="false"
      width="35%"
      center
    >
      <div class="text-center mb-3">
        <p class="dialog__text-warning font-xl" :title="titleRequest">
          Xác nhận Từ chối yêu cầu <br />
          "{{
            titleRequest
          }}"
        </p>
      </div>
      <el-form
        ref="formRejectRequest"
        :model="mData.dataFormRejectRequest"
        :rules="mData.validFormRejectRequest"
        @submit.native.prevent
        label-position="top"
        style="width: 90%; margin: 0 auto; border: none"
      >
        <b-row>
          <b-col>
            <el-form-item label="Lý do từ chối" prop="note">
              <el-input
                type="textarea"
                v-model="mData.dataFormRejectRequest.note"
                placeholder="Nhập nội dung"
                clearable
                show-word-limit
                maxlength="2000"
                resize="none"
                :autosize="{ minRows: 4 }"
              ></el-input>
            </el-form-item>
          </b-col>
        </b-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="fn_closeDialogReject"
          class="btn-back"
          >Đóng</el-button
        >
        <el-button
          @click="fn_rejectRequest"
          class="btn-default"
          >Từ chối</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import DataService from "../../../service/DataService";
import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
import ExtensionService from "../../../service/ExtensionService";
import RequestsModel from "./RequestsModel";
import EmployeeRequestApi from "../../../moduleApi/EmployeeRequestApi";
import EmployeeApi from "../../../moduleApi/EmployeeApi";
import { fnMixins } from "./RequestMixins/fnMixins";
import { dataMixins } from "./RequestMixins/dataMixins";
export default {
  mixins: [dataMixins, fnMixins],
  data() {
    return {
      aRole: MethodService.checkRole,
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      currentUser: MethodService.getCurrentUser(),
      currentCompany: MethodService.getCompanyInfo(),
      currentProfile: MethodService.getUserProfile(),
      mData: {
        data: [],
        moduleName: "RequestsWaitingForApproval",
        dialogFormImportNhanVien: false,
        tableRules: MethodService.copyObject(RequestsModel.tableRules),
        dataForm: MethodService.copyObject(RequestsModel.dataForm),
        dataDefault: {
          listTrangThai: [
            {
              value: "",
              label: "Tất cả",
              name: "ALL",
            },
            {
              value: "WAITING_FOR_APPROVAL",
              label: "Chờ duyệt",
              name: "WAITING_FOR_APPROVAL",
            },
            {
              value: "APPROVED",
              label: "Đã duyệt",
              name: "APPROVED",
            },
            {
              value: "REJECTED",
              label: "Từ chối",
              name: "REJECTED",
            },
            {
              value: "NEED_APPROVAL",
              label: "Cần duyệt",
              name: "NEED_APPROVAL",
            },
          ],
          listLoaiLyDo: DataService.listLoaiLyDo,
          listTrangThaiForm: DataService.listTrangThai,
          listFeature: MethodService.getListFeatures(),
        },
        listEmployee: [],
        created_atFrom: "",
        created_atTo: "",
      },
      activeTab: "ALL",
      tabName: "ALL",
      listAllReq: [],
      listReqWaittingForApproval: [],
      listReqApproved: [],
      listReqRejected: [],
      listReqNeedApproval: [],
      resReqWaittingForApproval: "",
      resReqApproved: "",
      resReqRejected: "",
      resReq: "",
      resReqNeedApproval: "",
      dataPerPage: [],
      dataFilter: "",
      amountTime: "",
      employeeId: undefined,
      dialogInstruction: false,
      idReqDelete: undefined,
      myReq: true,
      approval_user_id: '',
      dialogRejectRequest: false,
      titleRequest: '',
      idReqReject: '',
      selectedRequests: [],
      isBulkProcessing: false,
    };
  },

  computed: {
    searchStatus: {
      get() {
        if (this.tabName == "ALL") {
          return this.mData.tableRules.dataSearch.value.status || "";
        }
        return this.tabName;
      },
      set(value) {
        if (this.tabName == "ALL") {
          this.mData.tableRules.dataSearch.value.status = value;
        }
      },
    },

    selectableRequestsOnPage() {
      if (this.tabName != "NEED_APPROVAL") {
        return [];
      }
      return this.dataPerPage.filter((row) => this.fn_isRowSelectable(row));
    },

    selectedRequestsOnPageCount() {
      return this.selectableRequestsOnPage.filter((row) =>
        this.fn_isRequestSelected(row)
      ).length;
    },

    isAllCurrentPageSelected() {
      return (
        this.selectableRequestsOnPage.length > 0 &&
        this.selectedRequestsOnPageCount == this.selectableRequestsOnPage.length
      );
    },

    isCurrentPageSelectionIndeterminate() {
      return (
        this.selectedRequestsOnPageCount > 0 &&
        this.selectedRequestsOnPageCount < this.selectableRequestsOnPage.length
      );
    },

    selectAllCurrentPage: {
      get() {
        return this.isAllCurrentPageSelected;
      },
      set(checked) {
        this.fn_toggleSelectAllCurrentPage(checked);
      },
    },
  },

  methods: {
    fn_getRequestContentDisplay(row) {
      if (!row) {
        return "";
      }
      if (row.type !== "WIFI_ATTENDANCE") {
        return row.content || "";
      }
      if (!row.content) {
        return "";
      }
      try {
        const parsedContent = JSON.parse(row.content);
        return parsedContent && parsedContent.note ? parsedContent.note : "";
      } catch (error) {
        return row.content || "";
      }
    },

    handleClick(tab) {
      this.tabName = tab.name;
      this.fn_clearSelectedRequests();
      if (this.tabName == "ALL") {
        this.fn_setDataTab(this.listAllReq, this.resReq);
      }
      if (this.tabName == "WAITING_FOR_APPROVAL") {
        this.fn_setDataTab(
          this.listReqWaittingForApproval,
          this.resReqWaittingForApproval
        );
      }
      if (this.tabName == "APPROVED") {
        this.fn_setDataTab(this.listReqApproved, this.resReqApproved);
      }
      if (this.tabName == "REJECTED") {
        this.fn_setDataTab(this.listReqRejected, this.resReqRejected);
      }
      if (this.tabName == "NEED_APPROVAL") {
        this.fn_setDataTab(this.listReqNeedApproval, this.resReqNeedApproval);
      }
      this.$router
        .replace({
          name: "Admin-ManageRequests-RequestsWaitingForApproval",
          query: {
            limit: this.mData.tableRules.limit,
            page: this.mData.tableRules.page,
            sort: this.mData.tableRules.sort,
            filters: this.mData.tableRules.filters || undefined,
            showFormSearch: this.mData.tableRules.showFormSearch,
            tab: this.tabName,
            process: this.myReq,
            fromScreen: this.$route.query.fromScreen
          },
        })
        .catch((err) => {
          // console.log(err);
        });
    },

    async fn_getListEmployee() {
      const employeeApiRes = await EmployeeApi.list({
        fields: "employee_no,administrative_info,image_id",
        limit: 5000,
      });
      if (employeeApiRes.result && employeeApiRes.result.length > 0) {
        this.mData.listEmployee = employeeApiRes.result;
      }
    },

    async fn_initTable() {
      if (
        (this.employeeId &&
          !this.mData.dataDefault.listFeature.includes("FT1001") &&
          !this.mData.dataDefault.listFeature.includes("FT1003")) ||
        (this.employeeId &&
          !this.mData.dataDefault.listFeature.includes("FT1001") &&
          this.mData.dataDefault.listFeature.includes("FT1003"))
      ) {
        this.dataFilter = {
          filters:
            this.mData.tableRules.filters +
            (this.mData.tableRules.filters ? "&" : "") +
            "employee_id=" +
            this.currentUser.id +
            "|approval_users.approval_user_id=" +
            this.currentUser.id,
        };
      } else if (
        this.employeeId &&
        this.mData.dataDefault.listFeature.includes("FT1001") &&
        this.mData.dataDefault.listFeature.includes("FT1003")
      ) {
        this.dataFilter = { filters: "" };
      } else {
        this.dataFilter = { filters: "" };
        // account company doesnt contain waitting for approval tab
        this.mData.dataDefault.listTrangThai = [
          {
            value: "",
            label: "Tất cả ",
            name: "ALL",
          },
          {
            value: "APPROVED",
            label: "Đã duyệt",
            name: "APPROVED",
          },
          {
            value: "REJECTED",
            label: "Từ chối",
            name: "REJECTED",
          },
          {
            value: "NEED_APPROVAL",
            label: "Cần duyệt",
            name: "NEED_APPROVAL",
          },
        ];
      }

      if (this.mData.tableRules.allowPaging) {
        this.dataFilter.limit = this.mData.tableRules.limit;
        this.dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        this.dataFilter.sort = this.mData.tableRules.sort;
      }
      await this.fn_dataTableFilter(this.dataFilter.filters);
    },

    async fn_getEmployeeById() {
      const res = await EmployeeApi.findById(this.currentUser.id);
      if (res.result) {
        this.employeeId = res.result.id;
      }
    },

    async fn_dataTableFilter(filter) {
      const allSearchFilters = this.mData.tableRules.filters || "";
      const tabSearchFilters = allSearchFilters
        .split("&")
        .filter((part) => part && !part.startsWith("status="))
        .join("&");
      const withSearch = (base) =>
        [base, tabSearchFilters].filter(Boolean).join("&");

      const totalReq = EmployeeRequestApi.list({
        filters: filter ? filter : allSearchFilters,
        limit: 9999,
        sort: this.mData.tableRules.sort,
      });
      const totalReqWaittingForApproval = EmployeeRequestApi.list({
        filters:
          (filter &&
          !this.mData.dataDefault.listFeature.includes("FT1001") &&
          !this.mData.dataDefault.listFeature.includes("FT1003") ||
          filter &&
          !this.mData.dataDefault.listFeature.includes("FT1001") &&
          this.mData.dataDefault.listFeature.includes("FT1003") ||
          !filter &&
          this.mData.dataDefault.listFeature.includes("FT1001") &&
          this.mData.dataDefault.listFeature.includes("FT1003")
            ? "employee_id=" + this.currentUser.id + "&"
            : "") + withSearch("status=WAITING_FOR_APPROVAL"),
        limit: 9999,
        sort: this.mData.tableRules.sort,
      });
      const totalReqApproved = EmployeeRequestApi.list({
        filters:
          (filter &&
          !this.mData.dataDefault.listFeature.includes("FT1001") &&
          !this.mData.dataDefault.listFeature.includes("FT1003") ||
          filter &&
          !this.mData.dataDefault.listFeature.includes("FT1001") &&
          this.mData.dataDefault.listFeature.includes("FT1003")
            ? withSearch(`employee_id=$$user_id|approval_users.approval_user_id=$$user_id&status=APPROVED`)
            : withSearch("status=APPROVED")),
        limit: 9999,
        sort: this.mData.tableRules.sort,
      });
      const totalReqRejected = EmployeeRequestApi.list({
        filters:
          (filter &&
          !this.mData.dataDefault.listFeature.includes("FT1001") &&
          !this.mData.dataDefault.listFeature.includes("FT1003") ||
          filter &&
          !this.mData.dataDefault.listFeature.includes("FT1001") &&
          this.mData.dataDefault.listFeature.includes("FT1003")
            ? withSearch(`employee_id=$$user_id|approval_users.approval_user_id=$$user_id&status=REJECTED`)
            : withSearch("status=REJECTED")),
        limit: 9999,
        sort: this.mData.tableRules.sort,
      });

      const firstDayOfCurrentMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString()
      const lastDayOfCurrentMonth = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0, 23, 59, 59).toISOString()

      const totalReqNeedApproval = EmployeeRequestApi.list({
        filters: filter &&
          !this.mData.dataDefault.listFeature.includes("FT1001") &&
          !this.myReq &&
          ( this.mData.dataDefault.listFeature.includes("FT1003") ||
            !this.mData.dataDefault.listFeature.includes("FT1003")
          )
            ? withSearch(`approval_users.approval_user_id=$$user_id&status=WAITING_FOR_APPROVAL${this.$route.query.fromScreen ? '&created_at>=' + firstDayOfCurrentMonth + '&created_at<=' + lastDayOfCurrentMonth : ''}`)
            : withSearch(`status=WAITING_FOR_APPROVAL${this.$route.query.fromScreen ? '&created_at>=' + firstDayOfCurrentMonth + '&created_at<=' + lastDayOfCurrentMonth : ''}`),
        limit: 9999,
        sort: this.mData.tableRules.sort,
      });

      const requestApproverParams = {
        tab: 'REQUEST_APPROVER',
        limit: 9999,
        skip: 0,
        sort: this.mData.tableRules.sort
      };
      if (this.mData.tableRules.dataSearch.value.type) {
        requestApproverParams.type = this.mData.tableRules.dataSearch.value.type;
      }
      if (this.mData.created_atFrom) {
        requestApproverParams.from = MethodService.toIsoDate(
          this.fn_createdAtFilterDateToDate(this.mData.created_atFrom)
        );
      }
      if (this.mData.created_atTo) {
        const createdAtTo = this.fn_createdAtFilterDateToDate(
          this.mData.created_atTo
        );
        createdAtTo.setHours(23, 59, 0);
        requestApproverParams.to = MethodService.toIsoDate(createdAtTo);
      }
      const totalReqMyTurnNeedApproval = EmployeeRequestApi.GetEmployeeRequestByStatus(
        requestApproverParams
      );
      await Promise.all([
        totalReqWaittingForApproval,
        totalReqApproved,
        totalReqRejected,
        totalReq,
        this.myReq && !this.currentProfile.type ? totalReqMyTurnNeedApproval : totalReqNeedApproval,
      ]).then((values) => {
        this.resReqWaittingForApproval = values[0];
        this.resReqApproved = values[1];
        this.resReqRejected = values[2];
        this.resReq = values[3];
        this.resReqNeedApproval = values[4];
        if (
          this.myReq &&
          !this.currentProfile.type &&
          allSearchFilters &&
          this.resReqNeedApproval
        ) {
          const employeeId = this.mData.tableRules.dataSearch.value.employee_id;
          const approvalUserId = this.approval_user_id;
          const requests = Array.isArray(this.resReqNeedApproval.result)
            ? this.resReqNeedApproval.result
            : [];
          const result = requests.filter((item) =>
            (!employeeId || item.employee_id == employeeId) &&
            (!approvalUserId || (item.approval_users || []).some(
              (user) => user.approval_user_id == approvalUserId
            ))
          );
          this.resReqNeedApproval = Object.assign({}, this.resReqNeedApproval, {
            result,
            meta: Object.assign({}, this.resReqNeedApproval.meta, {
              total: result.length,
            }),
          });
        }

        this.listAllReq = this.resReq.result;
        this.listReqWaittingForApproval = this.resReqWaittingForApproval.result;
        this.listReqApproved = this.resReqApproved.result;
        this.listReqRejected = this.resReqRejected.result;
        this.listReqNeedApproval = this.resReqNeedApproval.result;

        this.fn_setLabelTab();
        this.fn_changeDataRespectively();
      });
    },

    fn_setLabelTab() {
      let totalReq = 0;
      if (this.mData.dataDefault.listTrangThai.length == 5) {
        totalReq = this.resReq.meta.total;
        this.mData.dataDefault.listTrangThai[0].label =
          "Tất cả (" + totalReq + ")";
        this.mData.dataDefault.listTrangThai[1].label =
          "Chờ duyệt (" + this.resReqWaittingForApproval.meta.total + ")";
        this.mData.dataDefault.listTrangThai[2].label =
          "Đã duyệt (" + this.resReqApproved.meta.total + ")";
        this.mData.dataDefault.listTrangThai[3].label =
          "Từ chối (" + this.resReqRejected.meta.total + ")";
        this.mData.dataDefault.listTrangThai[4].label =
          "Cần duyệt (" + this.resReqNeedApproval.meta.total + ")";
      } else {
        totalReq = this.resReq.meta.total;
        this.mData.dataDefault.listTrangThai[0].label =
          "Tất cả (" + totalReq + ")";
        this.mData.dataDefault.listTrangThai[1].label =
          "Đã duyệt (" + this.resReqApproved.meta.total + ")";
        this.mData.dataDefault.listTrangThai[2].label =
          "Từ chối (" + this.resReqRejected.meta.total + ")";
        this.mData.dataDefault.listTrangThai[3].label =
          "Cần duyệt (" + this.resReqNeedApproval.meta.total + ")";
      }
    },

    fn_changeDataRespectively() {
      if (this.resReq) {
        this.fn_changeData(this.listAllReq);
      }
      if (this.resReqWaittingForApproval) {
        this.fn_changeData(this.listReqWaittingForApproval);
      }
      if (this.resReqApproved) {
        this.fn_changeData(this.listReqApproved);
      }
      if (this.resReqRejected) {
        this.fn_changeData(this.listReqRejected);
      }
      if (this.resReqNeedApproval) {
        this.fn_changeData(this.listReqNeedApproval);
      }
    },

    fn_setDataTab(listData, res) {
      this.fn_clearSelectedRequests();
      this.mData.tableRules.data = listData;
      this.dataPerPage = this.fn_tableChangeOffset(1);
      this.mData.tableRules.total = res.meta.total;
      this.mData.tableRules.page = res.meta.offset / res.meta.limit + 1;
      if (
        this.mData.tableRules.offset == res.meta.total &&
        this.mData.tableRules.offset != 0
      ) {
        this.mData.tableRules.offset = 0;
        this.mData.tableRules.page = 1;
      }
    },

    async fn_defaultDataTable() {
      if (this.tabName == "ALL") {
        this.fn_setDataTab(this.listAllReq, this.resReq);
      }
      if (this.tabName == "WAITING_FOR_APPROVAL") {
        this.fn_setDataTab(
          this.listReqWaittingForApproval,
          this.resReqWaittingForApproval
        );
      }
      if (this.tabName == "APPROVED") {
        this.fn_setDataTab(this.listReqApproved, this.resReqApproved);
      }
      if (this.tabName == "REJECTED") {
        this.fn_setDataTab(this.listReqRejected, this.resReqRejected);
      }
      if (this.tabName == "NEED_APPROVAL") {
        this.fn_setDataTab(this.listReqNeedApproval, this.resReqNeedApproval);
      }
    },

    async fn_defaultDataTableHash() {
      if (this.tabName == "ALL") {
        this.fn_setDataTabAfterManipulation(this.listAllReq, this.resReq);
      }
      if (this.tabName == "WAITING_FOR_APPROVAL") {
        this.fn_setDataTabAfterManipulation(
          this.listReqWaittingForApproval,
          this.resReqWaittingForApproval
        );
      }
      if (this.tabName == "APPROVED") {
        this.fn_setDataTabAfterManipulation(this.listReqApproved, this.resReqApproved);
      }
      if (this.tabName == "REJECTED") {
        this.fn_setDataTabAfterManipulation(this.listReqRejected, this.resReqRejected);
      }
      if (this.tabName == "NEED_APPROVAL") {
        this.fn_setDataTabAfterManipulation(this.listReqNeedApproval, this.resReqNeedApproval);
      }
    },

    fn_setDataTabAfterManipulation(listData, res) {
      this.fn_clearSelectedRequests();
      this.mData.tableRules.data = listData;
      this.dataPerPage = this.fn_tableChangeOffset(this.mData.tableRules.page);
      this.mData.tableRules.total = res.meta.total;
      this.mData.tableRules.page = this.$route.query.page
        ? this.$route.query.page
        : res.meta.offset / res.meta.limit + 1;
      if (
        this.mData.tableRules.offset == res.meta.total &&
        this.mData.tableRules.offset != 0
      ) {
        this.mData.tableRules.offset = 0;
        this.mData.tableRules.page = 1;
      }
    },

    //xử lý dữ liệu đầu ra
    async fn_changeData(resData) {
      const sameCompanyIds = new Set(this.mData.listEmployee.map(e => e.id));
      for (let i = resData.length - 1; i >= 0; i--) {
        if (!sameCompanyIds.has(resData[i].employee_id)) {
          resData.splice(i, 1);
        }
      }
      resData.forEach((item) => {
        if (item.status == "WAITING_FOR_APPROVAL") {
          item.status_format = "Chờ duyệt";
        } else if (item.status == "APPROVED") {
          item.status_format = "Đã duyệt";
        } else if (item.status == "REJECTED") {
          if(item.cancel_request == true){
            item.status_format = "Hủy bỏ";
          }
          else{
            item.status_format = "Từ chối";
          }
        }
        if (item.type == "DAY_OFF") {
          item.loai = "Nghỉ làm";
        } else if (item.type == "GO_LATE") {
          item.loai = "Đi muộn";
        } else if (item.type == "COME_BACK_SOON") {
          item.loai = "Về sớm";
        } else if (item.type == "WORK_EXPLANATION") {
          item.loai = "Giải trình công";
        } else if (item.type == "GO_OUT") {
          item.loai = "Ra ngoài";
        } else if (item.type == "GO_ON_BUSSINESS") {
          item.loai = "Công tác";
        } else if (item.type == "TIME_KEEPING_ONLINE") {
          item.loai = "Chấm công online";
        } else if (item.type == "WIFI_ATTENDANCE") {
          item.loai = "Điểm danh thủ công";
        } else if (item.type == "OT") {
          item.loai = "Làm thêm giờ";
        }
        this.mData.listEmployee.find((e) => {
          if (item.employee_id == e.id) {
            item.name = e.administrative_info.name.full_name
            if (e.image_id) {
              item.avt = ExtensionService.urlImg + e.image_id + "&r=square&w=512";
            } else {
              item.avt = ExtensionService.urlImg + e.administrative_info.avatar_id + "&r=square&w=512";
            }

          }
        });
        const inListApproval = (item.approval_users || []).find(
          (e) => e.approval_user_id == this.currentUser.id
        );
        if (inListApproval) {
          item.showBtnApproval = true;
        }
        if (
          this.mData.dataDefault.listFeature.includes("FT1003") ||
          item.employee_id == this.currentUser.id ||
          inListApproval
        ) {
          item.showBtnDetail = true;
        }
      });
      return resData;
    },

    fn_formatTime(value) {
      return MethodService.formatDate(value, "datetime");
    },

    fn_isRowSelectable(row) {
      return this.tabName == "NEED_APPROVAL" && row.showBtnApproval;
    },

    fn_isRequestSelected(row) {
      return this.selectedRequests.some((selectedRow) => selectedRow.id == row.id);
    },

    fn_selectionChange(rows) {
      this.selectedRequests = rows.filter((row) => row.showBtnApproval);
    },

    fn_toggleSelectAllCurrentPage(checked) {
      if (this.$refs.requestTable) {
        this.$refs.requestTable.clearSelection();
        if (checked) {
          this.selectableRequestsOnPage.forEach((row) => {
            this.$refs.requestTable.toggleRowSelection(row, true);
          });
        }
        return;
      }
      this.selectedRequests = checked ? [...this.selectableRequestsOnPage] : [];
    },

    fn_toggleRequestSelection(row, checked) {
      if (this.$refs.requestTable) {
        this.$refs.requestTable.toggleRowSelection(row, checked);
        return;
      }
      if (checked) {
        if (!this.fn_isRequestSelected(row)) {
          this.selectedRequests = [...this.selectedRequests, row];
        }
      } else {
        this.selectedRequests = this.selectedRequests.filter(
          (selectedRow) => selectedRow.id != row.id
        );
      }
    },

    fn_clearSelectedRequests() {
      this.selectedRequests = [];
      this.$nextTick(() => {
        if (this.$refs.requestTable) {
          this.$refs.requestTable.clearSelection();
        }
      });
    },

    async fn_refreshAfterApprovalAction() {
      await this.fn_initTable();
      await this.fn_defaultDataTable();
      this.fn_clearSelectedRequests();
    },

    async fn_approveRequests(rows) {
      for (const row of rows) {
        await EmployeeRequestApi.AppovalRequest({ id: row.id });
      }
    },

    async fn_rejectRequests(rows, note) {
      for (const row of rows) {
        await EmployeeRequestApi.UnAppovalRequest({
          id: row.id,
          note: note ? note.trim() : '',
        });
      }
    },

    fn_handleBulkApprove() {
      if (this.selectedRequests.length == 0) return;
      this.$confirm(
        `Bạn có chắc chắn muốn duyệt ${this.selectedRequests.length} yêu cầu đã chọn không?`,
        {
          confirmButtonText: LanguageService.lang.c_approve,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "success",
        }
      )
        .then(async () => {
          try {
            this.isBulkProcessing = true;
            await this.fn_approveRequests([...this.selectedRequests]);
            await this.fn_refreshAfterApprovalAction();
            window.toastr.success("Duyệt các yêu cầu đã chọn thành công !");
          } catch (error) {
            window.toastr.error(
              error.meta
                ? error.meta.field
                : "Có lỗi xảy ra khi duyệt các yêu cầu đã chọn !"
            );
          } finally {
            this.isBulkProcessing = false;
          }
        })
        .catch(() => {});
    },

    fn_handleBulkDisapprove() {
      if (this.selectedRequests.length == 0) return;
      this.dialogRejectRequest = true;
      this.titleRequest = `${this.selectedRequests.length} yêu cầu đã chọn`;
      this.idReqReject = this.selectedRequests.map((row) => row.id);
    },

    // handle even buttons
    fn_handle(type, index, row) {
      if (type == "detail") {
        this.$router.push({
          name: "Admin-ManageRequests-CheckRequest",
          params: { id: row.id },
        });
      }
      if (type == "approve") {
        this.$confirm(LanguageService.lang.c_approveConfirm, {
          confirmButtonText: LanguageService.lang.c_approve,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "success",
        })
          .then(async () => {
            try {
              await this.fn_approveRequests([row]);
              await this.fn_refreshAfterApprovalAction();
              window.toastr.success("Duyệt yêu cầu thành công !");
            } catch (error) {
              window.toastr.error(error.meta.field);
            }
          })
          .catch(() => {});
      }
      if (type == "disapprove") {
        this.dialogRejectRequest = true;
        this.titleRequest = row.title;
        this.idReqReject = row.id;
      }
      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_delete,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning",
        })
          .then(async () => {
            if (row.processed) {
              this.dialogInstruction = true;
              this.idReqDelete = row.id;
            } else if (!row.processed) {
              await this.fn_delete(row.id);
              await this.fn_initTable();
              // duyệt xong có hàm này sẽ re-render lại table
              await this.fn_defaultDataTable();
            }
          })
          .catch(() => {});
      }
    },

    fn_rejectRequest() {
      this.$refs["formRejectRequest"].validate(async (valid) => {
        if (!valid) return false;
        try {
          const ids = Array.isArray(this.idReqReject)
            ? this.idReqReject
            : [this.idReqReject];
          const rows = ids.map((id) => ({ id }));
          await this.fn_rejectRequests(rows, this.mData.dataFormRejectRequest.note);
          await this.fn_refreshAfterApprovalAction();
          window.toastr.success(
            ids.length > 1
              ? "Từ chối các yêu cầu đã chọn thành công !"
              : "Từ chối yêu cầu thành công !"
          );
          await this.fn_closeDialogReject();
          this.dialogRejectRequest = false;
        } catch (error) {
          if (error.code == 404) {
            window.toastr.error(error.meta.field);
            this.dialogRejectRequest = false;
          } else {
            window.toastr.error("Có lỗi xảy ra khi từ chối yêu cầu !");
            this.dialogRejectRequest = false;
          }
          this.fn_closeDialogReject();
        }
      });
    },

    async fn_delete(id) {
      this.dialogInstruction = false;
      await EmployeeRequestApi.delete(id);
      await this.fn_initTable();
      await this.fn_defaultDataTable();
    },
    //event table
    async fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      await this.fn_initTable();
      await this.fn_defaultDataTable();
    },

    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch =
        !this.mData.tableRules.showFormSearch;
      let query = Object.assign({}, this.$route.query);
      query.showFormSearch = this.mData.tableRules.showFormSearch;
      this.$router.push({
        name: "Admin-ManageRequests-RequestsWaitingForApproval",
        query: query,
      });
    },

    //search
    fn_tableSearch() {
      if (!this.fn_validateCreatedAtFilters()) {
        MethodService.stopLadda();
        return;
      }
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          this.mData.tableRules.filters = MethodService.filterTable(
            JSON.stringify(this.mData.tableRules.dataSearch)
          );
          if (
            this.mData.tableRules.filters &&
            this.mData.tableRules.filters.includes("&approval_users.approval_user_id")
          ) {
            const approval_userIndex =
              this.mData.tableRules.filters.indexOf("&approval_users.approval_user_id");
            this.$route.query.filters =
              this.mData.tableRules.filters.substring(0, approval_userIndex) +
              this.mData.tableRules.filters.substring(approval_userIndex + 57);
            this.mData.tableRules.filters = this.$route.query.filters;
          } else if (
            this.mData.tableRules.filters &&
            this.mData.tableRules.filters.includes("approval_users.approval_user_id")
          ) {
            const approval_userIndex =
              this.mData.tableRules.filters.indexOf("approval_users.approval_user_id");
            this.$route.query.filters =
              this.mData.tableRules.filters.substring(0, approval_userIndex) +
              this.mData.tableRules.filters.substring(approval_userIndex + 56);
            this.mData.tableRules.filters = this.$route.query.filters;
          }
          if (this.approval_user_id) {
            this.mData.tableRules.filters += `&approval_users.approval_user_id=${this.approval_user_id}`;
          }
          if (
            this.mData.tableRules.filters &&
            this.mData.tableRules.filters.includes("&created_at")
          ) {
            // Index of "created_atFrom" on the route
            const indexCreated_atFrom =
              this.mData.tableRules.filters.indexOf("&created_at");
            // Cut "created_at" filters
            this.$route.query.filters =
              this.mData.tableRules.filters.substring(0, indexCreated_atFrom) +
              this.mData.tableRules.filters.substring(indexCreated_atFrom + 46);
            this.mData.tableRules.filters = this.$route.query.filters;
          } else if (
            this.mData.tableRules.filters &&
            this.mData.tableRules.filters.includes("created_at=")
          ) {
            // Cut "created_at" filters
            this.$route.query.filters =
              this.mData.tableRules.filters.substring(45);
            this.mData.tableRules.filters = this.$route.query.filters;
          }
          // Add filters "created_at"
          if (this.mData.created_atFrom) {
            this.mData.tableRules.filters +=
              "&created_at>=" +
              MethodService.toIsoDate(
                this.fn_createdAtFilterDateToDate(this.mData.created_atFrom)
              );
          }
          if (this.mData.created_atTo) {
            const createdAtTo = this.fn_createdAtFilterDateToDate(
              this.mData.created_atTo
            );
            createdAtTo.setHours(23, 59, 0);
            this.mData.tableRules.filters +=
              "&created_at<=" +
              MethodService.toIsoDate(createdAtTo);
          }
          this.mData.tableRules.page = 1;
          await this.fn_initTable();
          await this.fn_defaultDataTable();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    async fn_getListReqNeedApproval() {
      await this.fn_initTable();
      await this.fn_defaultDataTable();
      this.fn_clearSelectedRequests();
    },

    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.dataPerPage = this.fn_tableChangeOffset(1);
      this.fn_clearSelectedRequests();
    },

    fn_tableCurentChange(page) {
      this.dataPerPage = this.fn_tableChangeOffset(page);
      this.fn_clearSelectedRequests();
    },

    fn_tablePrevClick(page) {
      this.dataPerPage = this.fn_tableChangeOffset(page);
      this.fn_clearSelectedRequests();
    },

    fn_tableNextClick(page) {
      this.dataPerPage = this.fn_tableChangeOffset(page);
      this.fn_clearSelectedRequests();
    },

    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      let start = (page - 1) * this.mData.tableRules.limit;
      let end = page * this.mData.tableRules.limit;
      if (this.mData.tableRules.showUrl) {
        this.$router
          .replace({
            name: "Admin-ManageRequests-RequestsWaitingForApproval",
            query: {
              limit: this.mData.tableRules.limit,
              page: this.mData.tableRules.page,
              sort: this.mData.tableRules.sort,
              filters: this.mData.tableRules.filters || undefined,
              showFormSearch: this.mData.tableRules.showFormSearch,
              tab: this.tabName,
              process: this.myReq,
              fromScreen: this.$route.query.fromScreen
            },
          })
          .catch((err) => {
            // console.log(err);
          });
      }
      return this.mData.tableRules.data.slice(start, end);
    },

    fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.showFormSearch == "true") {
        this.mData.tableRules.showFormSearch = true;
      }
      if (this.$route.query.showFormSearch == "false") {
        this.mData.tableRules.showFormSearch = false;
      }
      if (this.$route.query.process == "true") {
        this.myReq = true;
      }
      if (this.$route.query.process == "false") {
        this.myReq = false;
      }
      if (this.$route.query.tab) {
        this.tabName = this.$route.query.tab;
      }
      if (this.$route.query.filters) {
        this.fn_changeURL();
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = Object.assign(
          {},
          RequestsModel.tableRules.dataSearch.value,
          MethodService.stringToObject(this.mData.tableRules.filters)
        );
        if (this.mData.tableRules.dataSearch.value['approval_users.approval_user_id']) {
          this.approval_user_id = this.mData.tableRules.dataSearch.value['approval_users.approval_user_id'];
        }
      }
    },

    fn_changeURL() {
      if (
        this.$route.query.filters &&
        this.$route.query.filters.includes("&created_at")
      ) {
        const indexCreated_atFrom =
          this.$route.query.filters.indexOf("&created_at") + 1;
        const indexCreated_atTo =
          this.$route.query.filters.lastIndexOf("&created_at") + 1;
        const createdAppearanceBigger =
          this.$route.query.filters.search("&created_at>");
        const createdAppearanceSmaller =
          this.$route.query.filters.search("&created_at<");
        // Count appearance time of 'created_at'
        // const createdAppearanceTime = (this.$route.query.filters.match(/&created_at/g) || []).length;
        // console.log("createdAppearanceTime", createdAppearanceTime);
        // Fill data to input 'created_atFrom' 'created_atTo'
        if (createdAppearanceBigger !== -1) {
          this.mData.created_atFrom = this.fn_formatCreatedAtFilterDate(
            this.$route.query.filters.substr(indexCreated_atFrom + 12, 19)
          );
        }
        if (createdAppearanceSmaller !== -1) {
          this.mData.created_atTo = this.fn_formatCreatedAtFilterDate(
            this.$route.query.filters.substr(indexCreated_atTo + 12, 19)
          );
        }
        // Output URL need
        this.mData.tableRules.filters = this.$route.query.filters.substr(
          0,
          indexCreated_atFrom
        );
        this.$route.query.filters = this.$route.query.filters.substr(
          0,
          indexCreated_atFrom + 82
        );
      }
    },

    fn_getCreatedAtDateRawValue(field) {
      const refName =
        field == "created_atFrom" ? "createdAtFromPicker" : "createdAtToPicker";
      const picker = this.$refs[refName];
      const input =
        picker &&
        picker.$refs &&
        picker.$refs.reference &&
        picker.$refs.reference.$refs &&
        picker.$refs.reference.$refs.input;

      return input && input.value !== undefined
        ? String(input.value).trim()
        : String(this.mData[field] || "").trim();
    },

    fn_setCreatedAtDateInputValue(field, value) {
      const refName =
        field == "created_atFrom" ? "createdAtFromPicker" : "createdAtToPicker";
      this.mData[field] = value;
      this.$nextTick(() => {
        const picker = this.$refs[refName];
        const input =
          picker &&
          picker.$refs &&
          picker.$refs.reference &&
          picker.$refs.reference.$refs &&
          picker.$refs.reference.$refs.input;
        if (input) {
          input.value = value;
        }
      });
    },

    fn_parseCreatedAtFilterDate(value) {
      const rawValue = String(value || "").trim();
      if (!rawValue) {
        return { valid: true, empty: true };
      }
      if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(rawValue)) {
        return {
          valid: false,
          message: "Ngày không đúng định dạng DD/MM/YYYY",
        };
      }

      const parts = rawValue.split("/");
      const day = Number(parts[0]);
      const month = Number(parts[1]);
      const year = Number(parts[2]);
      const daysInMonth = [
        31,
        year % 400 == 0 || (year % 4 == 0 && year % 100 != 0) ? 29 : 28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31,
      ];

      if (
        day < 1 ||
        month < 1 ||
        month > 12 ||
        day > daysInMonth[month - 1]
      ) {
        return {
          valid: false,
          message: "Ngày không tồn tại",
        };
      }

      return {
        valid: true,
        formatted:
          String(day).padStart(2, "0") +
          "/" +
          String(month).padStart(2, "0") +
          "/" +
          String(year),
      };
    },

    fn_normalizeCreatedAtDateField(field, rawValue) {
      const result = this.fn_parseCreatedAtFilterDate(rawValue);
      if (result.empty) {
        this.fn_setCreatedAtDateInputValue(field, "");
        return true;
      }
      if (!result.valid) {
        this.fn_setCreatedAtDateInputValue(field, "");
        window.toastr.warning(result.message);
        return false;
      }
      this.fn_setCreatedAtDateInputValue(field, result.formatted);
      return true;
    },

    fn_handleCreatedAtDateBlur(field) {
      if (
        !this.fn_normalizeCreatedAtDateField(
          field,
          this.fn_getCreatedAtDateRawValue(field)
        )
      ) {
        return;
      }
      this.fn_checkValidTimeFilter();
    },

    fn_handleCreatedAtDateConfirm(field) {
      if (!this.fn_normalizeCreatedAtDateField(field, this.mData[field])) {
        return;
      }
      this.fn_checkValidTimeFilter();
    },

    fn_validateCreatedAtFilters() {
      const fields = ["created_atFrom", "created_atTo"];
      for (let i = 0; i < fields.length; i++) {
        const field = fields[i];
        if (
          !this.fn_normalizeCreatedAtDateField(
            field,
            this.fn_getCreatedAtDateRawValue(field)
          )
        ) {
          return false;
        }
      }
      return this.fn_checkValidTimeFilter();
    },

    fn_createdAtFilterDateToDate(value) {
      const parsed = this.fn_parseCreatedAtFilterDate(value);
      if (!parsed.valid || parsed.empty) {
        return undefined;
      }
      const parts = parsed.formatted.split("/");
      return new Date(Number(parts[2]), Number(parts[1]) - 1, Number(parts[0]));
    },

    fn_formatCreatedAtFilterDate(value) {
      if (!value) {
        return "";
      }
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) {
        return "";
      }
      return (
        String(date.getDate()).padStart(2, "0") +
        "/" +
        String(date.getMonth() + 1).padStart(2, "0") +
        "/" +
        String(date.getFullYear())
      );
    },

    fn_checkValidTimeFilter() {
      if (this.mData.created_atFrom && this.mData.created_atTo) {
        const created_atFrom = this.fn_createdAtFilterDateToDate(
          this.mData.created_atFrom
        );
        const created_atTo = this.fn_createdAtFilterDateToDate(
          this.mData.created_atTo
        );
        if (!created_atFrom || !created_atTo) {
          return false;
        }
        if (created_atFrom > created_atTo) {
          window.toastr.warning(
            "Thời gian tạo từ không được lớn hơn thời gian tạo tới"
          );
          return false;
        }
      }
      return true;
    },

    fn_goBack() {
      this.$router.go(-1);
    },
  },
  //run after render view
  async created() {
    if (this.$route.query.tab) {
      this.tabName = this.$route.query.tab;
      this.activeTab = this.$route.query.tab;
    } else {
      this.activeTab = "ALL";
      this.tabName = "ALL";
    }
    await this.fn_hashUrl();
    await this.fn_getEmployeeById();
    await this.fn_getListEmployee();
    await this.fn_initTable();
    if (this.$route.query.page > 1) {
      await this.fn_defaultDataTableHash();
      return;
    }
    await this.fn_defaultDataTable();
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.dialog__text-warning {
  max-width: 80%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin: 0px auto;
  padding-bottom: 15px;
  line-height: inherit;
}
::v-deep .dialog__reject-request .el-dialog__header {
  background-color: #fff !important;
  border-bottom: 0;
}
::v-deep .dialog__reject-request .el-dialog__body {
  padding: 20px 10px 0 10px;
}
::v-deep .content {
  overflow: hidden;
  text-overflow: ellipsis;
}
::v-deep .el-tabs--card>.el-tabs__header {
  border: none !important;
}
.el-table {
  border-radius: 10px;
  /* border: none; */
}
.bulk-request-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px;
  min-height: 34px;
  margin-bottom: 8px;
}
.bulk-request-actions__select-all {
  margin-left: 15px;
  margin-right: auto;
  color: #606266;
}
::v-deep .bulk-request-actions__select-all .el-checkbox__label {
  font-size: 13px;
  padding-left: 6px;
}
.bulk-request-actions__count {
  color: #606266;
  font-size: 13px;
}
::v-deep .bulk-request-actions__button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 140px;
  height: 36px;
  padding: 0 14px;
  margin-left: 0;
}
::v-deep .bulk-request-actions__button i {
  margin-right: 4px;
}
::v-deep.el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  border-bottom: 1px solid transparent;
}
.avt-circle {
  width: 40px;
  height: 40px;
  border: 1px solid var(--orange);
  border-radius: 50%;
  background: #757575;
  margin-right: 10px;
}
.avt-circle .avt-circle-innner {
  border-radius: 50%;
  width: 100%;
  height: 100%;
  object-fit: contain;
}
::v-deep .el-avatar--circle {
  border: 1px solid var(--orange);
}
::v-deep .el-input__prefix,
.el-input__suffix {
  right: 5px;
  left: auto;
}
::v-deep .el-input--suffix .el-input__inner {
  padding-left: 15px;
  padding-right: 15px;
}
::v-deep .status__block {
  min-width: 84px;
  padding: 1px 8px;
  text-align: center;
  border-radius: 5px;
  &.waiting {
    color: #3db82b;
    background: #cef1c2;
  }
  &.approved {
    color: white;
    background: #6bc457;
  }
  &.rejected {
    color: var(--red);
    background: #f4e3e4;
  }
  &.cancel {
    color: var(--red);
    background: #f4e3e4;
  }
}
.request-list-section {
  margin-top: -13px;
}
.request-mobile-list {
  display: none;
}
@media (max-width: 1366px) and (max-width: 1440px) {
  ::v-deep .content.name {
    max-width: 140px;
  }
}
@media (max-width: 1600px) and (max-width: 1920px) {
  ::v-deep .content.name {
    max-width: 140px;
  }
}
@media (max-width: 767px) {
  .animated,
  .card,
  .main-card-body,
  .main-body,
  .main-body-table {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    box-sizing: border-box;
    overflow-x: hidden;
  }

  .card {
    border: 0;
    box-shadow: none;
    background: transparent;
  }

  .main-card-body {
    padding: 0;
  }

  .request-page-header {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
    min-width: 0;
  }

  .request-page-title,
  .request-page-actions {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    text-align: left !important;
  }

  .request-page-title h4 {
    margin-bottom: 0;
    font-size: 20px;
    line-height: 1.25;
    word-break: normal;
  }

  .request-page-actions__inner {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    justify-content: flex-start;
  }

  .request-page-actions__inner .el-button {
    margin-left: 0;
    min-height: 38px;
    white-space: normal;
  }

  .main-body-search ::v-deep .el-card__body {
    padding: 12px;
  }

  .main-body-search ::v-deep .el-select,
  .main-body-search ::v-deep .el-date-editor {
    width: 100%;
  }

  .request-tabs-row {
    margin-left: 0 !important;
    margin-right: 0;
    min-width: 0;
  }

  .request-tabs-col,
  .request-tabs-wrapper {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    padding-left: 0;
    padding-right: 0;
  }

  .request-status-tabs {
    width: 100%;
    max-width: 100%;
    overflow: hidden;
  }

  .request-status-tabs ::v-deep .el-tabs__header {
    max-width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
  }

  .request-status-tabs ::v-deep .el-tabs__nav-wrap,
  .request-status-tabs ::v-deep .el-tabs__nav-scroll {
    overflow: visible;
  }

  .request-status-tabs ::v-deep .el-tabs__nav {
    display: flex;
    float: none;
    white-space: nowrap;
    transform: none !important;
  }

  .request-status-tabs ::v-deep .el-tabs__item {
    flex: 0 0 auto;
    min-width: max-content;
    padding: 0 6px;
  }

  .request-unhandled-filter {
    width: 100%;
    padding-left: 0 !important;
    text-align: left !important;
  }

  .request-list-section {
    margin-top: 8px;
  }

  .request-desktop-table {
    display: none;
  }

  .request-mobile-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
    max-width: 100%;
  }

  .request-card {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    padding: 12px;
    border-radius: 8px;
    background: #fff;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
    box-sizing: border-box;
  }

  .request-card__header {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
  }

  .request-card__selection {
    flex: 0 0 auto;
    margin-right: 0;
  }

  .request-card__identity {
    min-width: 0;
    flex: 1;
  }

  .request-card__name {
    font-weight: 600;
    color: #333;
    overflow-wrap: anywhere;
  }

  .request-card__type {
    margin-top: 2px;
    font-size: 13px;
    font-weight: 600;
    color: #666;
    overflow-wrap: anywhere;
  }

  .request-card__content {
    margin-top: 10px;
    color: #555;
    line-height: 1.4;
    overflow-wrap: anywhere;
    word-break: break-word;
  }

  .request-card__content span {
    font-weight: 600;
    color: #444;
  }

  .request-card__meta {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    margin-top: 10px;
  }

  .request-card__time {
    color: #666;
    font-size: 13px;
  }

  .request-card__actions {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 12px;
  }

  .request-card__actions .el-button {
    min-height: 36px;
    margin-left: 0;
  }

  .request-pagination-row {
    margin-left: 0;
    margin-right: 0;
  }

  .request-pagination-col {
    padding-left: 0;
    padding-right: 0;
    text-align: left !important;
  }

  .request-pagination {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
    white-space: normal;
  }

  .request-pagination ::v-deep button,
  .request-pagination ::v-deep .el-pager li {
    min-width: 36px;
    height: 36px;
    line-height: 36px;
  }

  .request-pagination ::v-deep .el-pagination__sizes,
  .request-pagination ::v-deep .el-pagination__jump,
  .request-pagination ::v-deep .el-pagination__total {
    margin: 0;
  }

  .request-pagination ::v-deep .el-pager li:not(.active):not(:first-child):not(:last-child) {
    display: none;
  }
}
@media (max-width: 380px) {
  .request-page-actions__inner .el-button,
  .request-card__actions .el-button {
    width: 100%;
  }

  .request-pagination ::v-deep .el-pagination__jump {
    display: none;
  }
}
</style>
